<template lang='pug'>
v-main
  v-container(fluid)
    div(style="display: flex;justify-content: space-between;padding: 1rem;background: white;padding-bottom: .2rem;")
      p(style="font-size: 1.25rem;line-height: 1.5;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;") Edit Memo IM Announcement
      v-btn(v-if="$route.name !== 'Forex Request' && $route.name !== 'Document Legal F1' && $route.name !== 'Document Legal F2'" color='blue-secondary' to='/my-request') LIST MEMO

    v-dialog(v-model='dialogInactiveApprover' persistent='' max-width='370')
      v-card
        v-card-title(style="display: flex; justify-content: center; font-size:40px;")
          v-icon.mr-2(
            style="margin-top:1rem; font-size:40px;"
            title="edit",
            color="red",
            @click="onEdit(item.id, item.user_id)"
          )
            | error
        v-card-text(style="font-size:16px; text-align: center;margin-top:1rem")
          | {{ errorActiveUserMsg}}
        v-card-actions(style="justify-content: center;")
          v-btn(style="background: #1976D2; color: white; margin-bottom:1rem; width:80%" text='' @click='dialogInactiveApprover = false')
            | OK
    v-stepper(v-model="e1")
      v-stepper-header
        v-stepper-step(:complete="e1 > 1" step="1")
          | Subject
        v-divider
        v-stepper-step(:complete="e1 > 2" step="2")
          | Details
        v-divider
        v-stepper-step(:complete="e1 > 2" step="2")
          | Approver
      v-stepper-items
        v-stepper-content(step="1")
          v-card.mb-2(style="box-shadow: none")
            //- | HALAMAN `1`
            v-card(flat)
              v-card-text.p-5
                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    v-subheader(color="black")
                      | &nbsp;Business Unit&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-autocomplete(
                      style="padding: 0",
                      id="imSelectBU",
                      label="Select Business Unit",
                      :items="myBuList",
                      :disabled="tempDataPaymentL.imStatus != 1",
                      item-text="label",
                      item-value="value",
                      v-model="imAnchSelectedBU",
                      placeholder="Select",
                      required
                      @change="trigerChange"
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Subject&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-text-field(
                      id="imSubject",
                      style="padding: 0",
                      label="Subject",
                      v-model="imAnchSubject"
                    )
                
                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;From&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-text-field(
                      id="imFrom",
                      style="padding: 0",
                      label="From",
                      v-model="imAnchFrom"
                    )
                
                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;To&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-text-field(
                      id="imTo",
                      style="padding: 0",
                      label="To",
                      v-model="imAnchTo"
                    )
          v-btn(id="imPage1Cancel", depressed, large, style="background-color: #f5f5f5;" text="" @click="$router.push('/my-request')") Cancel
          v-btn(id="imPage1Next", depressed, large, style="margin: 0.5rem" :disabled="form1Validation" color="primary", @click="e1 = 2") Next
        v-stepper-content(step="2")
          v-card(style="box-shadow: none")
            v-card(flat)
              p(v-if="vNullAncDtl" style='color:red') Announcement Details is Required
              <textarea id="editor4" name="editor4"></textarea>
          v-btn(id="imPage2Cancel", depressed, large, style="margin: 0.3rem; background-color: #f5f5f5;" text="" @click="$router.push('/my-request')") Cancel
          v-btn(id="imPage2Back", depressed, large, style="margin: 0.3rem; background: #607D8B; color:#fff", @click="e1 = 1") Back
          v-btn(id="imPage2Next", depressed, large, style="margin: 0.3rem" color="primary", @click="getMyBUMember();") Next
        v-stepper-content(step="3" style="padding:0")
          v-alert(
            style="margin:0"
            dismissible,
            color="red",
            dark,
            v-model="alert",
            transition="scale-transition"
          ) {{ alertMessage }}
          v-card(style="box-shadow: none; padding:1rem 1rem; border-top: 1px solid #adadad;")
            div(style="display: flex;width: 100%;justify-content: space-between;")
              div(v-if="( this.$store.state.dataEditRequest.imStatus == 1 )" style="padding:0 1rem; flex:1")
                v-autocomplete(
                  style="padding: 0; margin:.5",
                  label="Approver",
                  id="imInternalApprover",
                  :items="myBuMember",
                  v-model="approver",
                  placeholder="Select",
                  chips,
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data",
                  return-object,
                  multiple,
                  :append-icon="'close'"
                  @click:append="handleClearEvent(1)"
                  :readonly="max_total_approver !== 0 ? approver.length >= max_total_approver : false"
                )
                  template(v-slot:selection="data")
                    v-chip(
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="removeApp(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{ data.item.alias }} - {{ data.item.position }} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}

                v-autocomplete(
                  :search-input.sync='searchCrossBU' 
                  style="padding: 0; margin:.5",
                  label="Approver Cross BU",
                  id="imCrossApprover",
                  v-model="approver",
                  chips
                  color="blue-grey lighten-2"
                  :items="crosBuMember",
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data"
                  multiple
                  :append-icon="'close'"
                  @click:append="handleClearEvent(2)"
                  hide-no-data='' 
                  hint="Enter at least 3 letters to find out the search results."
                  return-object=true
                  :readonly="max_total_approver !== 0 ? approver.length >= max_total_approver : false"
                )
                  template(v-slot:selection="data")
                    v-chip.chip--select-multi(
                      :selected="data.selected",
                      close,
                      @click:close="removeApp(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{ data.item.alias }} - {{ data.item.position }} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}

                v-autocomplete(
                  style="padding: 0; margin:.5",
                  label="CC",
                  id="imInternalCC",
                  v-model="tembusan",
                  :items="getCCData",
                  chips,
                  color="blue-grey lighten-2",
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data",
                  return-object,
                  multiple,
                  :append-icon="'close'"
                  @click:append="handleClearEvent(3)"
                  @change="removeCc()"
                  hide-details
                )
                  template(v-slot:selection="data")
                    v-chip.chip--select-multi(
                      :selected="data.selected",
                      close,
                      @click:close="removeCc(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{data.item.alias}} - {{data.item.position}} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}
                        //- v-list-tile-sub-title(v-html="data.item.title")

                small(style="color: #F08703;" ) *CC can only view memo, cannot approve memo.

                v-autocomplete(
                  :search-input.sync='searchCrossCC',
                  style="padding: 0; margin:.5",
                  label="Cross CC",
                  id="imCrossCC",
                  v-model="tembusan",
                  :items="getCrossCCData",
                  chips,
                  color="blue-grey lighten-2",
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data",
                  multiple,
                  :append-icon="'close'"
                  @click:append="handleClearEvent(4)",
                  hide-no-data='',
                  @change="removeCc()",
                  hint="Enter at least 3 letters to find out the search results.",
                  return-object=true
                )
                  template(v-slot:selection="data")
                    v-chip.chip--select-multi(
                      :selected="data.selected",
                      close,
                      @click:close="removeCc(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{data.item.alias}} - {{data.item.position}} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}
                        //- v-list-tile-sub-title(v-html="data.item.title")
                v-flex.autocomplete-result.d-flex.flex-row.align-center.mt-3
                  v-checkbox.mr-2(
                    id="imCBHideTTL",
                    v-model="disabledHidetitle",
                    label="Hide Title",
                    :disabled="useAlias"
                  )
                  v-checkbox(id="imCBUseAls", v-model="useAlias" label="Use Alias Name")
                  v-checkbox(id="imCBShowLogo", style='margin-left:1rem' v-model="useLogo" label="Show Company Logo")
                
                p(style="color: #F08703; font-size: 12px" class="mb-0" v-if="use_setting_max_approver && max_total_approver !== 0") *Each memo may have a maximum of ({{max_total_approver}}) approvers assigned within your Business Unit. Kindly ensure that the approver list does not exceed this limit.

              div(style="padding:0 1rem; flex:1")
                div(v-if="( this.$store.state.dataEditRequest.imStatus == 1 )").badge-approval.d-flex.mt-0() 
                  .mr-3
                    img(src="../assets/icon/ic_tips.svg")
                  .align-self-center
                    i Tips: Drag and drop the approver by holding down the left mouse and dragging them. (Approval sequence follow when user input the approver)

                template
                  .mb-5.mt-5
                    p.title.mb-1 Approver
                    ol.autocomplete-results(v-show="approver")
                      draggable.list-group(
                        :list="approver",
                        :disabled="this.tempDataPaymentL.imStatus != 1",
                        ghost-class="ghost",
                        @start="draggings = true",
                        @end="draggings = false"
                      )
                        li.autocomplete-result(
                          v-for="(requestor, i) in approver"
                          :key="requestor.id"
                        )
                          v-chip.list-group-item.ma-1(v-if="tempDataPaymentL.imStatus == 1" @click:close="removeApp(requestor)",x-large,close,label) 
                            div
                              p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                              p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                              p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Approver is not active
                          v-chip.ma-1(v-else, label x-large) 
                            div
                              p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                              p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                              p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Approver is not active
                template
                  .mb-5.mt-5
                  p.title.mb-1 CC
                  ol.autocomplete-results(v-show="tembusan")
                    li.autocomplete-result(
                      v-for="(requestor, i) in tembusan",
                      key="i"
                    )
                      v-chip.ma-1(v-if="tempDataPaymentL.imStatus == 1" @click:close="removeCc(requestor)" label, x-large ,close) 
                        div
                          p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                          p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                          p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Account is not active
                      v-chip.ma-1(v-else, label x-large) 
                        div
                          p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                          p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                          p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Account is not active
          v-btn(id="imPage3Cancel", depressed, large, text="" style="background-color: #f5f5f5;margin-left: 1.5rem"  @click="$router.push('/my-request')") Cancel
          v-btn(id="imPage3Back", style="margin-left: 0.5rem" dark, color="blue-grey", depressed, large, @click="e1 = 2") Back
          v-btn.ml-2(
            v-if="this.$store.state.dataEditRequest.imStatus == 1"
            id="imPage3btnDraft",
            color="info",
            depressed,
            large,
            :disabled="approver.length == 0 || isLoading",
            @click="submitMemo(1)"
          )
            v-icon insert_drive_file
            | &nbsp; Save as Draft
          //- WithdrawDialog( :disableds="isLoading", small class='mr-2' v-if="this.$store.state.dataEditRequest.imStatus == 3 && $route.name == 'Edit Memo Announcement' && this.$store.state.dataUsers._id == this.$store.state.dataEditRequest.imUser._id" :imId="this.$store.state.dataEditRequest._id" :type="this.$store.state.dataEditRequest.imType" creator)
          v-btn(
            id="imPage3btnSubmit",
            style="margin: 0.5rem" 
            depressed,
            large,
            color="success",
            :disabled="approver.length == 0 || isLoading",
            @click="submitMemo(2)"
          ) 
            v-icon send
            | &nbsp; Submit Request
          
</template>

<script>
import axios from "axios";
//- import * as masterBank from "../data/bank.json";
import draggable from "vuedraggable";
import WithdrawDialog from "@/components/WithdrawWizard.vue";
export default {
  components: {
    draggable,
    WithdrawDialog
  },
  data() {
    return {
      useLogo: true,
      errorActiveUserMsg:'',
      dialogInactiveApprover:false,
      vNullAncDtl: false,
      dialogChangeCurency: false,
      dialogConfirmDelete: false,
      tempDeleteItem: null,
      pickerStyle: false,
      money: {
        decimal: ',',
        thousands: '.',
        precision: 0,
        masked: false,
        suffix: ' IDR',
      },
      moneyUSD: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: false,
        suffix: ' USD',
      },
      moneyAdd: {
        decimal: ',',
        thousands: '.',
        precision: 0,
        masked: false,
      },
      moneyUSDAdd: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: false,
      },
      isLoading: false,
      isCopy: this.$route.fullPath.includes('copyIM') ? true: false,
      btnLoader: false,
      masterBank: [],
      searchCrossCC: '',
      searchCrossBU: '',
      e1: 1,
      alertMessage:"",
      alert: false,
      draggings: false,
      approver:[],
      tembusan:[],
      myBuMember:[],
      crosBuMember:[],
      listCrossCC:[],
      totalPayment:0,
      myBuList: [],
      imAnchSelectedBU: '',
      imAnchSubject:'',
      imAnchFrom:'',
      imAnchTo:'',
      useAlias: true,
      hideTitle: [],
      tempDataPaymentL: null,
      prevSelectedBUID: null,
      disabledHidetitle: false,
      max_total_approver: 0,
      use_setting_max_approver: true,
    };
  },

  computed: {
    form1Validation() {
      if (this.imAnchSelectedBU && this.imAnchSubject && this.imAnchFrom && this.imAnchTo ) return false
      return true
    },
    getCCData() {
      let result = []
      const tempDataPaymentCC = this.myBuMember
      for (let i in tempDataPaymentCC) {
        tempDataPaymentCC[i].isCros = false
        result.push(tempDataPaymentCC[i])
      }
      return result
    },
    
    getCrossCCData() {
      let result = []
      const tempDataPaymentCC = this.listCrossCC
      for (let i in tempDataPaymentCC) {
        tempDataPaymentCC[i].isCros = true
        result.push(tempDataPaymentCC[i])
      }
      
      return result
    },
  },
  methods: {
    trigerChange(e) {
      this.approver = []
      this.myBuMember = []
      this.crosBuMember = []
      this.tembusan = []
      this.listCrossCC = []
      if (this.use_setting_max_approver) {
        let token = localStorage.getItem("token");
        axios
          .get(
            process.env.VUE_APP_API +
              `/business-unit/detail/${this.imAnchSelectedBU.split('-')[1] ? this.imAnchSelectedBU.split('-')[1]: this.imAnchSelectedBU}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )
          .then((res) => {
            this.max_total_approver = res.data.max_approver ? res.data.max_approver : 0;
          })
          .catch((err) => {
            this.$toasted.error(err, { icon: "error" });
          })
      }
    },
    handleClearEvent(al) {
      let data1 = []
      let data2 = []
      let result = []
      if (al == 1) {
        data1 = this.approver
        data2 = this.myBuMember
      } else if (al == 2) {
        data1 = this.approver
        data2 = this.crosBuMember
      } else if (al == 3) {
        data1 = this.tembusan
        data2 = this.getCCData
      } else if (al == 4) {
        data1 = this.tembusan
        data2 = this.getCrossCCData
      }

      for ( let i in data1) {
        let isFound = false
        for (let j in data2) {
          if (data1[i].id == data2[j].id) isFound = true
        }
        if (!isFound) result.push(data1[i])
      }

      if (al == 1 || al == 2) this.approver = result
      else this.tembusan = result
    },
    disablePaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('text/plain');
      if (/^[^a-zA-Z]*$/.test(pastedData)) return
      event.preventDefault();
    },
    numberOnly(evt) {
      evt = (evt) ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      
      if (!/^[0-9]+$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    sumField(key) {
      const res = this.paymentItems.reduce((a, b) => +a + +(b[key] || 0), 0)
      this.totalPayment = res
      return res
    },
    removeCc(item) {
      let result = []
      for (const key in this.tembusan) if (this.tembusan[key].id != item.id) result.push(this.tembusan[key])
      this.tembusan = result
    },
    removeApp(item) {
      let result = []
      for (const key in this.approver) if (this.approver[key].id != item.id) result.push(this.approver[key])
      this.approver = result
    },
    countTotal() {
      let ttl = 0
      for (let i in this.paymentItems) ttl+= +this.paymentItems[i].amount
      this.totalPayment = ttl
    },
    editItem(item) {
      this.editedIndex = this.paymentItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
    },
    deleteItem() {
      const index = this.paymentItems.indexOf(this.tempDeleteItem);
      this.paymentItems.splice(index, 1);
      this.countTotal()
      this.tempDeleteItem = null
    },
    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    addNew() {
      if (!this.addItemName || !this.addItemPrice) return
      let id = 1
      for ( let i in this.paymentItems) {
        this.paymentItems[i].id = id
        id++
      }
      const addObj = Object.assign(
        {},
        {
          name: this.addItemName,
          amount: this.addItemPrice,
          currency: this.selectedCurrency.value,
        }
      );
      addObj.id = this.paymentItems.length + 1;
      this.paymentItems.unshift(addObj);
      this.editItem(addObj);
      this.save();

      this.addItemPrice = 0
      this.addItemName = ''
    },
    save() {
      if (!this.editedItem.amount || !this.editedItem.name) return
      if (this.editedIndex > -1) {
        Object.assign(this.paymentItems[this.editedIndex], this.editedItem);
      }
      this.countTotal()
      this.close();
    },
    changeCurency() {
      //- if (this.paymentItems) for(let i in this.paymentItems)this.paymentItems[i].currency = this.selectedCurrency.value
      this.paymentItems = []
    },
    async getMyActiveBU() {
      try{
        const token = localStorage.getItem("token");
        const userId = this.$store.state.dataUsers.user
        if (userId) {
          const reqDataBU = await axios.get(`${process.env.VUE_APP_API}/users/active/bu/${userId._id}`, { headers: { Authorization: `Bearer ${token}` }})
          const listBU = reqDataBU.data.data
          for (let i in listBU) {
            if (listBU.length == 1) listBU[i].label = `${listBU[i].business_unit.bu_name}`
            else listBU[i].label = `${listBU[i].business_unit.bu_name} as ${listBU[i].position ? listBU[i].position : ''}`
            listBU[i].value = `${listBU[i].id}-${listBU[i].business_unit.id}`
          }
          console.log(listBU)
          this.myBuList = listBU
        }
      } catch(e) {
        console.log(e)
      }
    },
    async getCrossBUMember() {
      try{
        const token = localStorage.getItem("token");
        this.crosBuMember = []
        const reqDataCrossBUMember = await axios.get(`${process.env.VUE_APP_API}/users/busines-unit/${this.imAnchSelectedBU.split('-')[0] ? this.imAnchSelectedBU.split('-')[0] : this.imAnchSelectedBU}`, { headers: { Authorization: `Bearer ${token}` }})
        const dataCrossBUMember = reqDataCrossBUMember.data.data
        for(let i in dataCrossBUMember) if (dataCrossBUMember[i].email != this.$store.state.dataUsers.user.email) for (let j in this.approver) if (this.approver[i].email == dataCrossBUMember[i].email) this.crosBuMember.push(dataCrossBUMember[i])
      } catch(e) {
        console.log(e)
      }
    },
    async getMyBUMember() {
      if (myEditor4.getData().trim() && myEditor4.getData().trim() != "<p>&nbsp;</p>") {
        this.e1 = 3
        try{
          const token = localStorage.getItem("token");
          const reqDataMyBUMember = await axios.get(`${process.env.VUE_APP_API}/users/bu/list/${this.imAnchSelectedBU.split('-')[1] ? this.imAnchSelectedBU.split('-')[1]: this.imAnchSelectedBU}`, { headers: { Authorization: `Bearer ${token}` }})
          const dataMyBUMember = reqDataMyBUMember.data.data
          this.myBuMember = dataMyBUMember
        } catch(e) {
          console.log(e)
        }
      } else {
        this.vNullAncDtl = true 
        setTimeout(()=> {
          this.vNullAncDtl = false 
        }, 2000)
      }
      
    },
    async submitMemo(act) {
      this.isLoading = true;
      let isNeedReview = this.status == 3 ? true : false;
      let isReSubmited = 0;
      try {
        const reqCreatorData = await axios.get(`${process.env.VUE_APP_API}/memo/creator/${this.imAnchSelectedBU.split('-')[0] ? this.imAnchSelectedBU.split('-')[0] : this.imAnchSelectedBU}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`
          }
        });
        let creator_data = reqCreatorData.data.data

        let chosenBUDetail = await axios.get(`${process.env.VUE_APP_API}/business-unit/detail/${this.imAnchSelectedBU.split('-')[1] ? this.imAnchSelectedBU.split('-')[1]: this.imAnchSelectedBU}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`
          }
        });
        chosenBUDetail.data.id = chosenBUDetail.data._id;
        delete chosenBUDetail.data._id;

        //- CONTAIN INTERNAL AND CROSS BU APPV
        const approvers = [];


        if (this.tembusan) {
          for (const item of this.tembusan) { 
            if (!item.is_active) {
              this.errorActiveUserMsg = this.tempDataPaymentL.imStatus == 3 ? "Sorry, there is inactive account. Please contact admin or withdraw memo.": "Sorry, there is inactive account. Please close or change new account."
              this.dialogInactiveApprover = true
              this.isLoading = false;
              this.status = statusBeforeSubmit;
              return
            }
          }
        }


        for (const item of this.approver) {
          if (!item.is_active) {
            this.errorActiveUserMsg = this.tempDataPaymentL.imStatus == 3 ? "Sorry, there is inactive account. Please contact admin or withdraw memo.": "Sorry, there is inactive account. Please close or change new account."
            this.dialogInactiveApprover = true
            this.isLoading = false;
            this.status = statusBeforeSubmit;
            return
          }
          if (typeof item.comment === "undefined") {
            this.$set(item, "comment", null);
          }

          if (this.useAlias) {
            this.$set(item, "name", item.name);
          }

          this.$set(item, "postAs", "approver");

          approvers.push(item);
        }
        

        let newApp = approvers
        if (act == 2 && newApp[0].status == null) newApp[0].status = 9;
        else if (this.tempDataPaymentL.imStatus > 1) {
          var imWf = [ ...approvers];
          newApp = [];
          var statusBefore = 7;
          
          for (const item of imWf) {
            if (
              (item.status == 9 || item.status == 3) && 
              this.$store.state.dataEditRequest.imUser.id != this.$store.state.dataUsers.user._id
            ) {
              item.status = 7;
              item.comment = "";
              item.date = new Date();
            }
            if (item.status == null && statusBefore == 7) item.status = 9;
            if (item.status == 6 && statusBefore == 7) item.status = 9;
            statusBefore = item.status;
            newApp.push(item);
          }

          if (isNeedReview && newApp[0].status == 9) {
            isReSubmited = 1;
          }
        }

        let formData = new FormData();

        let isRoleCreator = false; 
        let tempDataImUser = this.tempDataPaymentL.imUser
        let selectedBUs = this.imAnchSelectedBU.split('-')[0] ? this.imAnchSelectedBU.split('-')[0] : this.imAnchSelectedBU
        for ( let dataUserBU of this.$store.state.dataUsers.user.bu ) {
          if ( dataUserBU.id == this.tempDataPaymentL.imUser.id ) {
            isRoleCreator = true
          }

          if (dataUserBU.id == selectedBUs) {
            tempDataImUser = dataUserBU
            tempDataImUser.name = this.$store.state.dataUsers.user.full_name
            tempDataImUser.label = dataUserBU.business_unit.bu_name
            tempDataImUser.value = dataUserBU.business_unit.id
          }
        }

        if (this.$store.state.dataEditRequest.imStatus == 1) {
          tempDataImUser = creator_data
          tempDataImUser.label = creator_data.business_unit.bu_name
          tempDataImUser.value = creator_data.business_unit.id
        }

        if ( !isRoleCreator ) {
          formData.append("isApproverEdit", 1);
        } else {
          formData.append("isApproverEdit", 0);
          formData.append("userId", this.$store.state.dataUsers.user._id);
        }
        formData.append("userId", this.$store.state.dataUsers.user._id);
        //- formData.append("user", JSON.stringify(creator_data));
        formData.append("imType", 7);
        //- formData.append("status", this.statusEdit);
        formData.append("imTujuan", this.imPayDataTujuan);
        formData.append("imStatus", act);

        if (this.$store.state.dataEditRequest.imStatus ==1 ) formData.append("imOrganization", JSON.stringify(chosenBUDetail.data));
        else formData.append("imOrganization", JSON.stringify(this.$store.state.dataEditRequest.imOrganization))

        formData.append("imTargetDate", new Date().toISOString().substr(0, 10));
        formData.append("imUseAlias", this.useAlias ? true : false);
        formData.append("imHideTitle", this.disabledHidetitle ? true : false);
        if (act == 2 && newApp[0].status == null) newApp[0].status = 9;
        formData.append("imApprover", JSON.stringify(newApp));
        formData.append("imCC", JSON.stringify(this.tembusan));
        formData.append("imGroup", "nongroup");
        formData.append("imPerihal", this.imAnchSubject.replaceAll(`"`, `'`));
        formData.append("imAnchFrom", this.imAnchFrom);
        formData.append("imAnchTo", this.imAnchTo);
        formData.append("imUseLogo", this.useLogo ? true : false);
        formData.append("imAnchDetail", myEditor4.getData().replace(/<meta charset="utf-8">/g, '').replace(/dir="ltr"/g,''));
        formData.append("imUser", JSON.stringify(tempDataImUser));
        formData.append("isReSubmited", isReSubmited);
        if ( this.$store.state.dataEditRequest.imStatus == 3 ) {
          formData.append("isNeedReview", 1);
        } else {
          formData.append("isNeedReview", 0);
        }
        

        //- const configSubmitMemoReqEdit = {
        //-   method: "post",
        //-   url: process.env.VUE_APP_API_OLD + `/api/requests`,
        //-   headers: { "Content-Type": "multipart/form-data" },
        //-   data: formData,
        //- };


        if ( this.$store.state.dataEditRequest.imStatus == 1) {
          const creatorID = this.$store.state.dataEditRequest.imUser.id
          const listLoginUserBU = this.$store.state.dataUsers.user.bu
          //- VALIDATE LOGIN USER HAVE SAME ID AS CREATOR MEMO
          for ( let i in listLoginUserBU ) if (listLoginUserBU[i].id == creatorID) formData.append("imDate", new Date().toISOString());
        }
        if ( this.tempDataPaymentL.imStatus == 3) formData.append("person", JSON.stringify(this.tempDataPaymentL.imReturn[this.tempDataPaymentL.imReturn.length -1]));
        if (this.tempDataPaymentL.imStatus == 1) formData.append("draft", "draft");
       // disabkled THIS
        const configSubmitMemoReqEdit = {
          method: "put",
          url: `${process.env.VUE_APP_API_OLD}/api/requests/${this.$store.state.dataEditRequest.imNo}/${this.$store.state.dataUsers.user._id}`,
          headers: { "Content-Type": "multipart/form-data" },
          data: formData,
        };

        const submitMemoReq = await axios(configSubmitMemoReqEdit)

        if (submitMemoReq.status == 200) {
          this.isLoading = false;
            act == 1 ? 
            this.$toasted.info( "Memo has been successfully saved to draft",{ icon: "save"})
            : 
            this.$toasted.success("Success, the memo was successfully generated and sent to the approver.",{ icon: "check_circle"})
            this.$router.push("/my-request");
        }

      } catch(e) {
        console.log(e.response)
        let error = e.response.data.message || 'Err'
        if (error != 'Err') this.$toasted.error(error, { icon: "error" });
        else this.$toasted.error(error, { icon: "error" });
        if (error.includes('Failed')) this.$router.push("/my-request");
      } finally {
        this.isLoading = false;
      }
    },
    setUseAlias() {
      if ( this.useAlias ) {
        this.disabledHidetitle = true
      }
    }
  },

  watch: {
    disabledHidetitle(val) {
      if (val) {
        for (const key in this.bod) {
          this.hideTitle.push(this.bod[key].id);
        }
      } else {
        this.hideTitle = [];
      }
    },

    useAlias(val) {
      
      if (val) {
        this.disabledHidetitle = true;
      } else if (this.disabledHidetitle == true && val == true) {
        this.disabledHidetitle = false;
        this.hideTitle = [];
      } else {
        this.hideTitle = [];
      }
    },
    async searchCrossCC(val) {
      try {
        if (val && val.length >= 3 && val.trim().length) {
          const token = localStorage.getItem("token");
          const {data} = await axios.get(`${process.env.VUE_APP_API}/users/busines-unit/${this.imAnchSelectedBU.split('-')[1] ? this.imAnchSelectedBU.split('-')[1]: this.imAnchSelectedBU}?key=${val}`,{
            headers: { Authorization: `Bearer ${token}` },
          })
          const res = data.data
          //- if (res.length != 0 ) this.listCrossCC = []
          for (let i in res ) if (res[i].is_active && res[i].name != this.$store.state.dataUsers.user.full_name) this.listCrossCC.push(res[i])
        }
      } catch(e) {
        if (e.response.status == 401 || e.response.status == 403) {
          this.$store.dispatch("logout");
          return this.$router.push("/");
            }
      } finally{
      }
    },
    async searchCrossBU(val) {
      try {
        if (val && val.length >= 3 && val.trim().length) {
          //- this.isLoading = true;
          const token = localStorage.getItem("token");
          const {data} = await axios.get(`${process.env.VUE_APP_API}/users/busines-unit/${this.imAnchSelectedBU.split('-')[1] ? this.imAnchSelectedBU.split('-')[1]: this.imAnchSelectedBU}?key=${val}`,{
            headers: { Authorization: `Bearer ${token}` },
          })
          const res = data.data
          //- if (res.length != 0 ) this.crosBuMember = []
          for (let i in res ) if (res[i].is_active && res[i].name != this.$store.state.dataUsers.user.full_name) this.crosBuMember.push(res[i])
        }
      } catch(e) {
        if (e.response.status == 401 || e.response.status == 403) {
          this.$store.dispatch("logout");
          return this.$router.push("/");
            }
      } finally{
        //- this.isLoading = false
      }
    },
    approver() {
      if (this.approver.length <= 0) {
        this.alert = false;
      }
      if (this.approver.length > 0) {
        let approver = this.approver[this.approver.length - 1];
        let isBreak = false;

        if (this.use_setting_max_approver && this.max_total_approver !== 0 && this.approver.length > this.max_total_approver) {
          this.alertMessage =
            `It reaches the maximum number (${this.max_total_approver}) of approver allowed in your BU!`;
          this.alert = true;
          this.approver.pop();
        } else {
          for (const iterator of this.tembusan) {
            if (isBreak) break;
            if (approver.id == iterator.id) {
              // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (Budget), silakan pilih salah satu!');
              this.alertMessage =
                "The user you selected has been selected in the previous input field, please choose one!";
              isBreak = true;
              this.alert = true;
              this.approver.pop();
              break;
            }
          }
        }
      }
    },
    tembusan() {
      if (this.tembusan.length > 0) {
        let tembusan = this.tembusan[this.tembusan.length - 1];
        let isBreak = false;

        for (const iterator of this.approver) {
          if (isBreak) break;
          if (tembusan.id == iterator.id) {
            // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (beside BOD), silakan pilih salah satu!');
            isBreak = true;
            this.alertMessage = "The user you selected has been selected in the previous input field, please choose one!";
            this.alert = true;
            this.tembusan.pop();
            break;
          }
        }
      }
    },
  },

  created() {},

  mounted: async function () {
    this.setUseAlias();

    this.$store.dispatch("fetchDataEditRequests", this.$route.params.id);
    //- const listBankResp = await axios.get(`${process.env.VUE_APP_API_OLD}/api/list_bank`)
    //- this.masterBank = listBankResp.data || []

    
    setTimeout(async()=> {
      let tempDataPayment = this.$store.state.dataEditRequest;
      for(let x = 0;x<10;x++){
      if(!tempDataPayment.imStatus){
          await new Promise(resolve => setTimeout(resolve, 1000));
          tempDataPayment = this.$store.state.dataEditRequest;
        }else{
          break
        }
      }
      try{
        if (tempDataPayment.imStatus != 1 && tempDataPayment.imStatus != 3 ) {  
          this.$toasted.error("Failed, memo has been submited", { icon: "error" });
          this.$router.push("/my-request");
        }
        if (tempDataPayment.imReturn) {
          const searchUserBUID = tempDataPayment.imReturn[tempDataPayment.imReturn.length-1].id
          const searchUserBUs = this.$store.state.dataUsers.user.bu
          let flag = false
          for(let i in searchUserBUs) if (searchUserBUs[i].id == searchUserBUID) flag = true
          if (tempDataPayment.imStatus == 3 && !flag) {
            this.$toasted.error("Failed, memo has been submited", { icon: "error" });
            this.$router.push("/my-request");
          }
        }
      } catch(e) {
        console.log(e)
      }

      //- DRAFT CONDITION ONLY THE CREATOR CAN OPEN THE PAGE
      if (tempDataPayment.imStatus == 1 && this.$store.state.dataUsers.user._id != tempDataPayment.userId) {
        this.$toasted.error("Failed, memo has been submited", { icon: "error" });
        this.$router.push("/my-request");
      }

      this.tempDataPaymentL = this.$store.state.dataEditRequest
      if (this.tempDataPaymentL.imStatus != 1) {
        this.tempDataPaymentL.imUser.label = this.$store.state.dataEditRequest.imUser.business_unit.bu_name
        this.tempDataPaymentL.imUser.value = this.$store.state.dataEditRequest.imUser.business_unit.id
        this.myBuList = this.tempDataPaymentL.imUser
      } else await this.getMyActiveBU();

      tempDataPayment.imUser.label = tempDataPayment.imUser.business_unit.bu_name
      tempDataPayment.imUser.value = tempDataPayment.imUser.business_unit.id

      this.imAnchSelectedBU = `${this.$store.state.dataEditRequest.imUser.id}`
      this.prevSelectedBUID = this.$store.state.dataEditRequest.imUser.business_unit.id
      this.imAnchSubject = this.$store.state.dataEditRequest.imPerihal
      this.imAnchFrom = this.$store.state.dataEditRequest.imAnchFrom
      this.imAnchTo = this.$store.state.dataEditRequest.imAnchTo
      this.useLogo = this.$store.state.dataEditRequest.imUseLogo == "false" ? false: true

      this.useAlias = this.$store.state.dataEditRequest.imUseAlias
      this.disabledHidetitle = this.$store.state.dataEditRequest.imHideTitle
      
      //- this.tembusan = tempDataPayment.tembusan
      const tempAppv = JSON.parse(tempDataPayment.imApprover)
      const tempAppvWF = tempDataPayment.imWorkflow
      for(let i in tempAppvWF) {
        if (this.isCopy) {
          tempAppvWF[i].status = null
          tempAppvWF[i].comment = undefined
          tempAppvWF[i].date = undefined
          tempAppvWF[i].action = undefined
        }
        if (tempAppv[i].isCros != false && tempAppv[i].business_unit.id != tempDataPayment.imUser.business_unit.id) this.crosBuMember.push(tempAppvWF[i])
      }

      let buid = ''
      if (this.$store.state.dataEditRequest.imStatus == 1) {
        this.imAnchSelectedBU = `${this.$store.state.dataEditRequest.imUser.id}-${this.$store.state.dataEditRequest.imUser.business_unit.id}`
        buid = this.$store.state.dataEditRequest.imUser.business_unit.id;
      } else {
        this.imAnchSelectedBU = this.$store.state.dataEditRequest.imOrganization.id
        buid = this.imAnchSelectedBU;
      }
      const token = localStorage.getItem("token");
      const reqDataBU = await axios.get(`${process.env.VUE_APP_API}/business-unit/detail/${buid}`, { headers: { Authorization: `Bearer ${token}` }})
      if (
        new Date(this.$store.state.dataEditRequest.imDate) >=
        new Date(process.env.CUT_OFF_MAX_APPROVER)
      ) {
        this.max_total_approver = reqDataBU.data.max_approver ? reqDataBU.data.max_approver : 0;
      } else {
        this.use_setting_max_approver = false;
      }

      this.approver = tempAppvWF

      //- const tempCC = 
      //- for(let i in tempAppv) if (tempAppv[i].isCros !== false) this.crosBuMember.push(tempAppv[i])
      this.tembusan = tempDataPayment.imCC

      const allCC = this.$store.state.dataEditRequest.imCC
      for (let i in allCC) if (allCC[i].isCros) this.listCrossCC.push(allCC[i])
      if (this.tempDataPaymentL.imStatus == 1) {
        let found = false
        for ( let i in this.myBuList) if (this.myBuList[i].value == this.imAnchSelectedBU) {
          found = true 
          break;
        }
        if (!found) this.imAnchSelectedBU = ''
      } else {
        const token = localStorage.getItem("token");
        const reqDataBU = await axios.get(`${process.env.VUE_APP_API}/business-unit/detail/${this.imAnchSelectedBU}`, { headers: { Authorization: `Bearer ${token}` }})
        if (!reqDataBU.data.is_active) this.imAnchSelectedBU = ''
      }
      
    }, 1000)

    setTimeout(() => {
      let memoScript = document.createElement('script')
      memoScript.setAttribute('src', '/js/memo.js')
      document.body.appendChild(memoScript)
    }, 1000)

    setTimeout(() => {
      const tempDataPayment = this.$store.state.dataEditRequest
      myEditor4.setData(tempDataPayment.imAnchDetail)
    }, 2000)
  }
};
</script>
<style >
.IMP-group-form {
  display: flex;
}

.IMP-title-form {
  margin: auto;
}

#dtbl th {
  background-color: #f0f0f0 !important; /* Ganti dengan warna yang diinginkan */
  color: #333; /* Ganti dengan warna teks yang diinginkan */
}
#dtbl th span {
  font-weight: bold;
  font-size: 18px;
}

#ThisToolbar .v-toolbar__content {
  padding: 0px !important;
  box-shadow: none !important;
}

td .v-money{
  text-align: right;
  width:90%;
}
th .v-money{
  text-align: right;
  width:90%;
}
</style>